import React, { FC, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Tips from '../common/Tips'

interface CategoryList {
  id: number
  category_name: string
  color: string
  parent_id: number | null
}

interface Props {
  categoryList: CategoryList[]
  labelGroupCategoryId: number | null
  parentId: number | null
  changeCallback: (parent_id: number | null) => void
  createCallback?: VoidFunction
  disable?: boolean
}

const AddLabelGroupCategoryModule: FC<Props> = (props) => {
  const {
    categoryList,
    labelGroupCategoryId,
    parentId,
    changeCallback,
    createCallback,
    disable,
  } = props

  const [isDisplay, setIsDisplay] = useState<boolean>(false)

  const open = () => {
    setIsDisplay(true)
  }

  const close = () => {
    setIsDisplay(false)
  }

  const changeParentGroupId = (id: number | null) => {
    changeCallback(id)
    setIsDisplay(false)
  }

  const openCreateProjectCategory = () => {
    if (!createCallback) return
    setIsDisplay(false)
    createCallback()
  }

  const buildCategoryList = (level = 0, parent_id?: number, disabled?: boolean, rules?: boolean[]):JSX.Element => {
    let list: CategoryList[] = []
    const levelCount = level + 1
    if (parent_id) {
      list = categoryList.filter((v) => v.parent_id === parent_id)
    } else {
      list = categoryList.filter((v) => v.parent_id === null)
    }
    if (!list.length) return (<></>)
    return (
      <>
        {
          list.map((v, i) => {
            const ruleList = [...rules?.map((rule, index) => (rules.length === index + 1 ? !rule : rule)) || [], list.length === i + 1]
            return (
              <React.Fragment key={`add_category_name_${v.category_name}_${i + 0}_${level}`}>
                <div
                  className={`row${labelGroupCategoryId === v.id || disabled ? " not_allowed" : ""}`}
                  onClick={() => !(labelGroupCategoryId === v.id || disabled) && changeParentGroupId(v.id)}
                  role="none"
                >
                  {
                    ruleList.map((w, j) => {
                      if (!j) return (<React.Fragment key={`${v.category_name}_${j + 0}_${level}`} />)
                      return (
                        <div
                          key={`${v.category_name}_${j + 0}_${level}`}
                          style={{
                            width: "14px",
                          }}
                        >
                          {
                            ruleList.length === j + 1 ? (
                              <>
                                {w ? (<>┗</>) : (<>┣</>)}
                              </>
                            ) : (
                              <>
                                {w && (<>┃</>)}
                              </>
                            )
                          }
                        </div>
                      )
                    })
                  }
                  <div className="row_detail">
                    <FontAwesomeIcon
                      icon={['fas', 'folder']}
                      className="icon"
                      style={{
                        color: v.color,
                        width: "16px",
                        height: "16px",
                      }}
                    />
                    {v.category_name}
                    {
                      parentId === v.id && (
                        <>
                          <div className="selected_label">
                            現在選択中
                          </div>
                        </>
                      )
                    }
                    {
                      (labelGroupCategoryId === v.id || disabled) && (
                        <>
                          <Tips
                            description="カテゴリー自身または子階層を親階層に設定することはできません"
                            className="side_view"
                            icon={false}
                          >
                            <>
                              <FontAwesomeIcon
                                icon={['fas', 'question-circle']}
                              />
                            </>
                          </Tips>
                        </>
                      )
                    }
                  </div>
                </div>
                {buildCategoryList(levelCount, v.id, labelGroupCategoryId === v.id || disabled, ruleList)}
              </React.Fragment>
            )
          })
        }
      </>
    )
  }

  return (
    <>
      <div className="project_category_area" style={{ backgroundColor: disable ? "#EEEEEE" : "" }}>
        <button
          type="button"
          className="select_area"
          onClick={() => !disable && open()}
        >
          {
            !!categoryList.find((v) => v.id === parentId) && (
              <FontAwesomeIcon
                icon={['fas', 'folder']}
                className="icon"
                style={{
                  color: categoryList.find((v) => v.id === parentId)?.color || "#DDDDDD",
                  width: "16px",
                  height: "16px",
                }}
              />
            )
          }
          {categoryList.find((v) => v.id === parentId)?.category_name || "未設定"}
        </button>
        <div className={`search_box select_category ${isDisplay || 'none'}`}>
          <div
            className="row"
            onClick={() => changeParentGroupId(null)}
            role="none"
          >
            <div className="row_detail">
              未設定
              {
                !parentId && (
                  <>
                    <div className="selected_label">
                      現在選択中
                    </div>
                  </>
                )
              }
            </div>
          </div>
          {buildCategoryList()}
          {
            !!createCallback && (
              <button
                type="button"
                className="create_project_category"
                onClick={openCreateProjectCategory}
              >
                新しいプロジェクトカテゴリーを作成する
              </button>
            )
          }
        </div>
      </div>
      <div className={`close_screen ${isDisplay || 'none'}`} role="presentation" onClick={() => close()} />
    </>
  )
}

AddLabelGroupCategoryModule.defaultProps = {
  createCallback: undefined,
  disable: false,
}

export default AddLabelGroupCategoryModule
